import React, { useEffect, useState } from "react";
import { FaCheck, FaEye } from "react-icons/fa";
import useApi from "../../hooks/useApi";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";
import { UserMap } from "../../components/maps/MapCustom";
import { useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useDispatch } from "react-redux";
import { format } from "date-fns";

import QRCode from "qrcode.react";
import newsletterImage from '../../assets/img/newsletterImages.png';
import appStoreImage from '../../assets/img/AppStore.png';
import googlePlayImage from '../../assets/img/GetItOnGoogle.png';

const CampaignDetails = () => {
  const [spiner, setspiner] = useState(false);
  const [preroutes, setpreroutes] = useState([]);
  const dispatch = useDispatch();

  const [campaignData, setCampaignData] = useState({
    start_date: "",
    end_date: "",
    total_miles: null,
    total_hours: null,
    install_date: "",
    install_time: "",
    photoshoot_date: "",
    photoshoot_time: "",
    swarm_date: "",
    swarm_time: "",
    repair_date: "",
    repair_time: "",
    removal_date: "",
    removal_time: "",
    campaign_best_photo: "",
    after_installation_image: "",
    job_location: "",
    campaign_id: null
  });

  const [data, setData] = useState({
    before_installation: [],
    after_installation: [],
    during_campaign: [],
    after_removel: [],
    special_events: [],
  });

  const [previewImage, setPreviewImage] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const location = useLocation();
  const { id, vechile_id } = location.state;

  const { request } = useApi((formData) =>
    apiClient.post(`/campaign/campaign-photos/`, formData)
  );

  const [bitrixJobIds, setBitrixJobIds] = useState({
    install: "",
    photoshoot: "",
    swarm: "",
    repair: "",
    removal: "",
  });

  useEffect(() => {
    const fetch = async () => {
      try {
        setspiner(true);
        const response = await apiClient.get(
          `/campaign/campaign-details/${id}/`
        );
        setspiner(false);

        setCampaignData({
          campaign_id: response?.data?.id,
          start_date: response.data.start_date,
          end_date: response.data.end_date,
          total_miles: response.data.total_miles,
          total_hours: response.data.total_hours,
          install_date: response.data.install_date,
          install_time: response.data.install_time,
          photoshoot_date: response.data.photoshoot_date,
          photoshoot_time: response.data.photoshoot_time,
          swarm_date: response.data.swarm_date,
          swarm_time: response.data.swarm_time,
          repair_date: response.data.repair_date,
          repair_time: response.data.repair_time,
          removal_date: response.data.removal_date,
          removal_time: response.data.removal_time,
          campaign_best_photo: response.data.campaign_best_photo,
          after_installation_image: response.data.after_installation_image,
          job_location: response.data.job_location,
        });

        const fetchedData = response.data.images;
        setData({
          before_installation:
            fetchedData.before_installation_photos?.map(
              (photo) => photo.before_installation_photo
            ) || [],
          after_installation:
            fetchedData.after_installation_photos?.map(
              (photo) => photo.after_installation_photo
            ) || [],
          during_campaign:
            fetchedData.during_campaign_photos?.map(
              (photo) => photo.during_campaign_photo
            ) || [],
          after_removel:
            fetchedData.after_removal_photos?.map(
              (photo) => photo.after_removal_photo
            ) || [],
          special_events:
            fetchedData.special_event_photos?.map(
              (photo) => photo.special_event_photo
            ) || [],
        });

        setBitrixJobIds({
          install: response?.data?.install_bitrix_job_id,
          photoshoot: response?.data?.photoshoot_bitrix_job_id,
          swarm: response?.data?.swarm_bitrix_job_id,
          repair: response?.data?.repair_bitrix_job_id,
          removal: response?.data?.removal_bitrix_job_id,
        });
      } catch (error) {
        setspiner(false);
        console.log(error);
      }
    };
    fetch();
  }, [id]);

  const handleChange = (key, files) => {
    setData((prevData) => ({
      ...prevData,
      [key]: [...prevData[key], ...files],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    data.before_installation.forEach((file) => {
      if (file instanceof File) {
        formData.append("campaign_id", campaignData?.campaign_id)
        formData.append("before_installation_photos", file);
        formData.append("bitrix_job_id", bitrixJobIds?.install);
      }
    });

    data.after_installation.forEach((file) => {
      if (file instanceof File) {
        formData.append("campaign_id", campaignData?.campaign_id)
        formData.append("after_installation_photos", file);
        formData.append("bitrix_job_id", bitrixJobIds?.install);
      }
    });

    data.during_campaign.forEach((file) => {
      if (file instanceof File) {
        formData.append("campaign_id", campaignData?.campaign_id)
        formData.append("during_campaign_photos", file);
      }
    });

    data.after_removel.forEach((file) => {
      if (file instanceof File) {
        formData.append("campaign_id", campaignData?.campaign_id)
        formData.append("after_removal_photos", file);
        formData.append("bitrix_job_id", bitrixJobIds?.removal);
      }
    });

    data.special_events.forEach((file) => {
      if (file instanceof File) {
        formData.append("campaign_id", campaignData?.campaign_id)
        formData.append("special_event_photos", file);
        formData.append("bitrix_job_id", bitrixJobIds?.swarm);
      }
    });

    try {
      const result = await request(formData);
      if (result.data && result.status === 201) {
        toast.success("Campaign Successfully Updated");
        fetch();
      } else {
        toast.error("Error");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error uploading photos");
    }
  };



  const fetchsavelocation = async () => {
    const response = await apiClient.get(
      `/campaign/tracking/?vehicle_id=${vechile_id}`
    );
    setpreroutes(response.data);
  };

  useEffect(() => {
    fetchsavelocation();
  }, [vechile_id]);


  // const formatDate = (date, time, type) => {
  //   if (!date) return "";
  //   if (type === "start_date" || type === "end_date") {
  //     return format(new Date(date), "MM/dd/yyyy");
  //   }
  //   const dateTime = `${date}T${time}`;
  //   return format(new Date(dateTime), "MM/dd/yyyy; @ h:mm a");
  // };

  // Function to convert 24-hour time format to 12-hour format with AM/PM
  const convertTo12HourFormat = (timeString) => {
    if (!timeString) return "";

    const [hours, minutes] = timeString.split(':');
    if (!hours || !minutes) return ""; // Check for invalid time format

    let hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';

    hour = hour % 12;
    hour = hour ? hour : 12; // Convert '0' hour to '12'

    return `${hour}:${minutes} ${ampm}`;
  };

  // Function to format date and time
  const formatDate = (dateString, time, type) => {
    if (!dateString) return "";

    // Add UTC time information to the date
    const utcDateString = `${dateString}T00:00:00Z`; // Force to UTC
    const date = new Date(utcDateString);

    // Convert date to MM/DD/YYYY format
    const format_date = date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'UTC', // Use UTC instead of local time
    });

    if (type === "start_date" || type === "end_date") {
      return format_date; // Show only date
    }

    return `${format_date} @ ${convertTo12HourFormat(time)}`; // Show date and time
  };

  const handleViewImages = (images) => {
    setPreviewImage(images);
    setShowModal(true);
  };

  const ImageModal = ({ images }) => (
    <div className="modal" style={{ display: showModal ? "block" : "none" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Image Preview</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => setShowModal(false)}
            ></button>
          </div>
          <div className="modal-body">
            {images?.length > 0 &&
              images.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Preview ${index}`}
                  style={{ maxWidth: "100%", marginBottom: "10px" }}
                />
              ))}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {!spiner ? (
        <form onSubmit={handleSubmit}>
          <div className="site-content h-100">
            <div className="p-sm-2 p-1">
              <div className="site-content-body">
                <div className="container-fluid main_bg_color">
                  <div className="row">
                    <div className="col-md-8 px-md-2">
                      <div>
                        <div className="carousel-inner test-2">
                          <div className="carousel-item active">
                            <div className="row d-md-flex py-1 slider_border_radius">
                              <div className="col-md-6 px-2">
                                <div className="slider_line_height text_color">
                                  <div className="d-flex message_dot_Posetion">
                                    <span className="bottom_line mb-3">
                                      <h5>Details</h5>
                                    </span>
                                  </div>
                                  <p>
                                    <span className="fw-bold">Start Date:</span>
                                    <span>
                                      {" "}
                                      {formatDate(
                                        campaignData.start_date,
                                        campaignData.start_time,
                                        "start_date"
                                      )}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">End Date:</span>
                                    <span>
                                      {" "}
                                      {formatDate(
                                        campaignData.end_date,
                                        campaignData.end_time,
                                        "end_date"
                                      )}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Miles:
                                    </span>
                                    <span>
                                      {" "}
                                      {campaignData.total_miles} Miles
                                    </span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Hours:
                                    </span>
                                    <span>
                                      {" "}
                                      {campaignData.total_hours} Hours
                                    </span>
                                  </p>
                                  {/* <p>
                                    <span className="fw-bold">Location:</span>
                                    <span>
                                      {" "}
                                      {campaignData.job_location?.split(
                                        "|"
                                      )[0] || "N/A"}
                                    </span>
                                  </p> */}
                                </div>
                              </div>
                              <div className="col-md-6 px-2">
                                <div className="slider_img_height">
                                  <img
                                    src={campaignData.campaign_best_photo}
                                    className="img-fluid h-100 w-100"
                                    alt="Campaign Best"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="">
                            <div className="row d-md-flex py-1 slider_border_radius">
                              <div className="col-md-6 px-2">
                                <div className="slider_line_height text_color">
                                  <div className="d-flex message_dot_Posetion">
                                    <span className="bottom_line mb-3">
                                      <h5>Details</h5>
                                    </span>
                                  </div>
                                  <p>
                                    <span className="fw-bold">Install: </span>
                                    <span>
                                      {" "}
                                      {formatDate(
                                        campaignData.install_date,
                                        campaignData.install_time
                                      )}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">Photoshoot: </span>
                                    <span>
                                      {formatDate(
                                        campaignData.photoshoot_date,
                                        campaignData.photoshoot_time
                                      )}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">Swarm: </span>
                                    <span>
                                      {formatDate(
                                        campaignData.swarm_date,
                                        campaignData.swarm_time
                                      )}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">Repair: </span>
                                    <span>
                                      {formatDate(
                                        campaignData.repair_date,
                                        campaignData.repair_time
                                      )}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">Removal: </span>
                                    <span>
                                      {formatDate(
                                        campaignData.removal_date,
                                        campaignData.removal_time
                                      )}
                                    </span>
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-6 px-2">
                                <div className="slider_img_height">
                                  <img
                                    src={data?.after_installation_image}
                                    className="img-fluid h-100 w-100"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 px-md-2 mt-md-0 mt-2">
                      <div className="bg_more_deatils text_color p-3">
                        <span className="bottom_line mb-3">
                          <h5>Confirmed Requests</h5>
                        </span>
                        <p>
                          <span className="fw-bold">Install: </span>
                          <span>
                            {" "}
                            {formatDate(
                              campaignData.install_date,
                              campaignData.install_time
                            )}
                          </span>
                        </p>
                        <p>
                          <span className="fw-bold">Photoshoot: </span>
                          <span>
                            {formatDate(
                              campaignData.photoshoot_date,
                              campaignData.photoshoot_time
                            )}
                          </span>
                        </p>
                        <p>
                          <span className="fw-bold">Swarm: </span>
                          <span>
                            {formatDate(
                              campaignData.swarm_date,
                              campaignData.swarm_time
                            )}
                          </span>
                        </p>
                        <p>
                          <span className="fw-bold">Repair: </span>
                          <span>
                            {formatDate(
                              campaignData.repair_date,
                              campaignData.repair_time
                            )}
                          </span>
                        </p>
                        <p>
                          <span className="fw-bold">Removal: </span>
                          <span>
                            {formatDate(
                              campaignData.removal_date,
                              campaignData.removal_time
                            )}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-5 col-md-6 px-md-2 my-2">
                      <div className="test-2 bg_Map">
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "100%", height: "100%" }}
                        >
                          <img
                            src={newsletterImage}
                            alt="Download Rolling Ads App"
                            style={{ width: 300, height: 300 }}
                          />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 20 }}>
                          <a href="https://apps.apple.com/us/app/drive-rolling-adz/id6738464473" target="_blank" rel="noopener noreferrer">
                            <img src={appStoreImage} alt="Download on the App Store" style={{ width: 150, marginRight: '10px' }} />
                          </a>
                          <a href="https://play.google.com/store/apps/details?id=com.fabtechsol.izikrollingadz&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
                            <img src={googlePlayImage} alt="Get it on Google Play" style={{ width: 150 }} />
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 col-md-6">
                      <div className="row">
                        <div className="col-12 p-md-2">
                          <div className="test-2 pt-2 bg-white">
                            <span className="bottom_line ms-3">
                              <h5>Campaign Photos</h5>
                            </span>
                            <form action>
                              <div className="px-3 py-2 d-flex">
                                <div className="text-center mx-lg-4 py-2 img_input_color w-50">
                                  <i className="bi bi-file-earmark-ruled-fill" />
                                  <br />
                                  <label htmlFor="before_installation">
                                    Upload Files Here
                                  </label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    hidden
                                    id="before_installation"
                                    multiple
                                    onChange={(e) =>
                                      handleChange(
                                        "before_installation",
                                        Array.from(e.target.files)
                                      )
                                    }
                                  />
                                </div>
                                {data?.before_installation?.length > 0 && (
                                  <div className="d-flex align-items-center mr-2">
                                    <button
                                      type="button"
                                      className="btn btn-primary ms-2"
                                      onClick={() =>
                                        handleViewImages(
                                          data.before_installation
                                        )
                                      }
                                    >
                                      <FaEye />
                                    </button>
                                  </div>
                                )}
                                <div className="w-50 my-auto ps-lg-0 ps-3">
                                  <h5>Before Installation</h5>
                                  <p>
                                    Photos Uploaded:{" "}
                                    {data?.before_installation?.length}
                                  </p>
                                </div>
                              </div>
                              <div className="px-3 py-2 d-flex">
                                <div className="text-center mx-lg-4 py-2 img_input_color w-50">
                                  <i className="bi bi-file-earmark-ruled-fill" />
                                  <br />
                                  <label htmlFor="after_installation">
                                    Upload Files Here
                                  </label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    hidden
                                    id="after_installation"
                                    multiple
                                    onChange={(e) =>
                                      handleChange(
                                        "after_installation",
                                        Array.from(e.target.files)
                                      )
                                    }
                                  />
                                </div>
                                {data?.after_installation?.length > 0 && (
                                  <div className="d-flex align-items-center">
                                    <button
                                      type="button"
                                      className="btn btn-primary ms-2"
                                      onClick={() =>
                                        handleViewImages(
                                          data.after_installation
                                        )
                                      }
                                    >
                                      <FaEye />
                                    </button>
                                  </div>
                                )}
                                <div className="w-50 my-auto ps-lg-0 ps-3">
                                  <h5>After Installation</h5>
                                  <p>
                                    Photos Uploaded:{" "}
                                    {data?.after_installation?.length}
                                  </p>
                                </div>
                              </div>
                              <div className="px-3 py-2 d-flex">
                                <div className="text-center mx-lg-4 py-2 img_input_color w-50">
                                  <i className="bi bi-file-earmark-ruled-fill" />
                                  <br />
                                  <label htmlFor="during_campaign">
                                    Upload Files Here (min.15)
                                  </label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    hidden
                                    id="during_campaign"
                                    multiple
                                    onChange={(e) =>
                                      handleChange(
                                        "during_campaign",
                                        Array.from(e.target.files)
                                      )
                                    }
                                  />
                                </div>
                                {data?.during_campaign?.length > 0 && (
                                  <div className="d-flex align-items-center">
                                    <button
                                      type="button"
                                      className="btn btn-primary ms-2"
                                      onClick={() =>
                                        handleViewImages(data.during_campaign)
                                      }
                                    >
                                      <FaEye />
                                    </button>
                                  </div>
                                )}
                                <div className="w-50 my-auto ps-lg-0 ps-3">
                                  <h5>During Campaign</h5>
                                  <p>
                                    Photos Uploaded:{" "}
                                    {data?.during_campaign?.length}
                                  </p>
                                </div>
                              </div>
                              <div className="px-3 py-2 d-flex">
                                <div className="text-center mx-lg-4 py-2 img_input_color w-50">
                                  <i className="bi bi-file-earmark-ruled-fill" />
                                  <br />
                                  <label htmlFor="after_removel">
                                    Upload Files Here
                                  </label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    hidden
                                    id="after_removel"
                                    multiple
                                    onChange={(e) =>
                                      handleChange(
                                        "after_removel",
                                        Array.from(e.target.files)
                                      )
                                    }
                                  />
                                </div>
                                {data?.after_removel?.length > 0 && (
                                  <div className="d-flex align-items-center">
                                    <button
                                      type="button"
                                      className="btn btn-primary ms-2"
                                      onClick={() =>
                                        handleViewImages(data.after_removel)
                                      }
                                    >
                                      <FaEye />
                                    </button>
                                  </div>
                                )}
                                <div className="w-50 my-auto ps-lg-0 ps-3">
                                  <h5>After Removal</h5>
                                  <p>
                                    Photos Uploaded:{" "}
                                    {data?.after_removel?.length}
                                  </p>
                                </div>
                              </div>
                              <div className="px-3 py-2 d-flex">
                                <div className="text-center mx-lg-4 py-2 img_input_color w-50">
                                  <i className="bi bi-file-earmark-ruled-fill" />
                                  <br />
                                  <label htmlFor="special_events">
                                    Upload Files Here
                                  </label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    hidden
                                    id="special_events"
                                    multiple
                                    onChange={(e) =>
                                      handleChange(
                                        "special_events",
                                        Array.from(e.target.files)
                                      )
                                    }
                                  />
                                </div>
                                {data?.special_events?.length > 0 && (
                                  <div className="d-flex align-items-center">
                                    <button
                                      type="button"
                                      className="btn btn-primary ms-2"
                                      onClick={() =>
                                        handleViewImages(data.special_events)
                                      }
                                    >
                                      <FaEye />
                                    </button>
                                  </div>
                                )}
                                <div className="w-50 my-auto ps-lg-0 ps-3">
                                  <h5 className="text-primary">
                                    Special Event
                                  </h5>
                                  <p>
                                    Photos Uploaded:{" "}
                                    {data?.special_events?.length}
                                  </p>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="select-applies d-flex flex-column align-items-center justify-content-center">
                    <button className="btn_bgnone save-changes blue-clr p-3 fs-4 border-0">
                      <span className="pe-2">Save Changes</span>
                      <FaCheck />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      ) : (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <CircularProgress />
        </div>
      )}
      <ImageModal images={previewImage} />
    </div>
  );
};

export default CampaignDetails;
